import { render, staticRenderFns } from "./tail_menu.vue?vue&type=template&id=6d8696e6&scoped=true&"
import script from "./tail_menu.vue?vue&type=script&lang=js&"
export * from "./tail_menu.vue?vue&type=script&lang=js&"
import style0 from "./tail_menu.vue?vue&type=style&index=0&id=6d8696e6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8696e6",
  null
  
)

export default component.exports